module.exports = __webpack_public_path__ + "static/whatpeoplesay-7db2dc40fa4e1c3189fd0061d33df2df.png";